<template>
  <div id="home">
    <homelogo />

    <v-carousel
      hide-delimiter-background
      height="100%"
      width="80%"
      cycle
      :show-arrows="imageHeight!='xs'&imageHeight!='sm'?false:true"
      :hide-delimiters="imageHeight!='xs'&imageHeight!='sm'?false:true"
    >
      <v-carousel-item>
        <v-img class="text-center" src="@/assets/Home/carrusel/donacion_computadores.jpg">
          <!-- <v-col class="white--text centerButtons text-center"> -->
          <v-btn
            rounded
            x-large
            min-width="20%"
            class="r-btn centerButtons"
            color="orange"
            href="/donations"
          >Dona un computador</v-btn>
          <!-- </v-col> -->
        </v-img>
      </v-carousel-item>
      <v-carousel-item>
        <v-img src="@/assets/Home/carrusel/carrusel_2.jpg" class="box-center">
          <v-row>
            <v-col lg="6" md="6" sm="12" cols="12"></v-col>
            <v-col lg="6" md="6" sm="12" cols="12" class="text-center">
              <h1 class="parrafos1 white--text font-weight-black">
                Apoyamos a familias
                <br />llevando
                <br />acceso a tecnología
                <br />reacondicionada
                <br />como herramienta de
                <br />desarrollo sostenible
              </h1>
              <br />
              <v-btn rounded large color="orange" class="r-btn" href="/donations">Postúlate</v-btn>
            </v-col>
          </v-row>
        </v-img>
      </v-carousel-item>
      <v-carousel-item>
        <v-img src="@/assets/Home/carrusel/reacondicionamos.jpg">
          <v-card-text class="white--text centerButtons text-center">
            <v-btn rounded large color="orange" class="r-btn" href="/howDoWeDoIt">Reacondicionamos</v-btn>
          </v-card-text>
        </v-img>
      </v-carousel-item>
    </v-carousel>
    <v-img src="@/assets/Home/objeto_social/educacion.jpg">
      <v-row>
        <v-col class="imgcenter" sm="10" md="8" lg="4">
          <v-img
            max-width="100%"
            src="@/assets/Home/objeto_social/fondo_texto_educacion.png"
            class="box-center"
          >
            <v-row class="hidden-sm-and-down">
              <v-col cols="6" class="imgcenter">
                <br />
                <br />
                <h3
                  class="text-center titles3"
                >Con tu ayuda Camila podra hacer sus tareas en un compu reacondicionado.</h3>
                <br />
                <br />
                <br />
                <br />
              </v-col>
            </v-row>
            <v-row class="hidden-md-and-up">
              <v-col cols="6" class="imgcenter">
                <br />
                <br />
                <h2
                  class="text-center titles3"
                >Con tu ayuda Camila podra hacer sus tareas en un compu reacondicionado.</h2>
                <br />
                <br />
                <br />
                <br />
              </v-col>
            </v-row>
          </v-img>
          <v-row>
            <v-col cols="9" class="imgcenter">
              <h2 class="text-center white--text titles">
                Nuestra Fundación tiene como
                objeto social apoyar el desarrollo
                integral de la familia y primera
                infancia a través de proyectos
                sociales y ambientales.
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="9" class="imgcenter">
              <v-img src="@/assets/Home/objeto_social/familia.png"></v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-img>
    <br />
    <br />
    <br />
    <v-img src="@/assets/Home/nuestra_histora/fondo_nuestra_historia.png">
      <v-row>
        <v-col cols="8" sm="8" md="6" lg="6" class="imgcenter">
          <h2 class="text-center titles black--text">
            <font class="titles">
              “Este sueño comenzó hace 15
              años,
            </font> motivados por llevar
            tecnología a poblaciones
            vulnerables, lo que nunca
            pensamos fue en el impacto
            económico y ambiental que
            tuvo PCSHEK en la sociedad.”
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="6" class="imgcenter">
          <h3 class="text-center parrafosGreen">Yamile y Gonzalo</h3>
        </v-col>
      </v-row>
      <v-row id="test">
        <v-col class="imgcenter" cols="12" sm="12" md="6" lg="6">
          <v-img src="@/assets/Home/nuestra_histora/fundadores.png"></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="imgcenter text-center" cols="12" sm="12" md="6" lg="6">
          <v-btn
            rounded
            large
            color="orange"
            class="white--text r-btn"
            href="/aboutUs#nosotros"
          >Conoce nuestra historia</v-btn>
        </v-col>
      </v-row>
    </v-img>
    <br />
    <br />
    <br />
    <v-img src="@/assets/Home/como_lo_hacemos/reutilizamos.jpg">
      <v-row class="hidden-sm-and-down">
        <v-col lg="6" md="6" sm="12" cols="12" class="px-12 pt-12 mt-12 text-center">
          <p class="parrafos1 white--text font-weight-black">
            Reutilizamos los elementos móviles
            y tecnológicos dados de baja por
            empresas, hogares y otras
            instituciones, para transformárlos en
            herramientas de desarrollo humano.
          </p>
          <v-btn
            class="white--text r-btn"
            rounded
            large
            color="orange"
            href="/howDoWeDoIt"
          >Conoce más</v-btn>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6"></v-col>
      </v-row>
    </v-img>
    <br />
    <br />
    <v-row class="hidden-md-and-up px-12">
      <v-col cols="12" class="text-center">
        <p class="parrafos1 font-weight-black">
          Reutilizamos los elementos móviles
          y tecnológicos dados de baja por
          empresas, hogares y otras
          instituciones, para transformárlos en
          herramientas de desarrollo humano.
        </p>
        <v-btn class="white--text r-btn" rounded large color="orange" href="/howDoWeDoIt">Conoce más</v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6"></v-col>
    </v-row>
    <v-row class="box-center px-12">
      <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
        <h1 class="titles">
          Te presentamos a SHEK,
          nuestra mascota
        </h1>
        <br />
        <p class="parrafosblue">
          SHEK es una combinación de
          tecnologías obsoletas y modernas,
          que al ser unificadas en los
          laboratorios de PCSHEK dan como
          resultado nuestra visión y prácticas
          en el reacondicionamiento de
          nuestro país.
        </p>
      </v-col>
      <v-col cols="12" lg="6" md="6" sm="12">
        <v-img src="@/assets/Home/Mascota_SHEK/shek.jpg"></v-img>
      </v-col>
    </v-row>
    <v-img src="@/assets/Home/Apoyo_social/apoyo-social.jpg" class="box-center">
      <v-row class="text-center px-12 hidden-sm-and-down box-center">
        <v-col cols="12" sm="12" md="6" lg="6"></v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <h1 class="white--text titles">Apoyo Social</h1>
          <br />
          <p class="white--text parrafos1">
            Gracias a tus
            aportes tecnológicos,
            llegamos a los sectores más
            vulnerables de Colombia.
          </p>
          <br />
          <v-btn
            class="white--text r-btn"
            rounded
            large
            color="orange"
            href="/projects"
          >Conoce nuestros proyectos</v-btn>
        </v-col>
      </v-row>
    </v-img>
    <br />
    <br />
    <v-row class="text-center px-12 hidden-md-and-up">
      <v-col cols="12" class="text-center">
        <h1 class="titles5 font-weidth-black">Apoyo Social</h1>
        <br />
        <p class="parrafos1">
          Gracias a tus
          aportes tecnológicos,
          llegamos a los sectores más
          vulnerables de Colombia.
        </p>
        <br />
        <v-btn
          class="white--text r-btn"
          rounded
          large
          height="90px"
          color="orange"
          href="/projects"
        >Conoce nuestros <br>proyectos</v-btn>
      </v-col>
    </v-row>
    <br />
    <br />
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6" class="text-center">
        <v-row>
          <v-col cols="12">
            <h1 class="titles">Nuestros aliados</h1>
          <p class="parrafos1">
            Algunos de nuestros amigos en el camino
            por una sociedad más conectada.
          </p>
          </v-col>
          <v-col cols="12"><v-img width="100%" height="100%" src="@/assets/Home/Aliados/aliados_fundacion.jpg"></v-img></v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-carousel hide-delimiter-background dark height="100%" :show-arrows="false">
          <v-carousel-item>
            <v-img src="@/assets/Home/Aliados/marcas_aliadas.png"></v-img>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import homelogo from "@/components/homelogo/homelogo.vue";
export default {
  components: {
    homelogo
  },
  data: () => ({
    itemsAliados: [{ img: "" }]
  }),
  computed: {
    imageHeight() {
      return this.$vuetify.breakpoint.name;
    }
  },
  methods: {
    onClick(e, item) {
      e.stopPropagation();

      if (item.to || !item.href) return;

      this.$vuetify.goTo(item.href.endsWith("!") ? 0 : item.href);
    },
    onclickreturn() {
      this.$vuetify.goTo("/aboutUs#nosotros");
    }
  }
};
</script>
<style scoped>
.back {
  /* height:100%; */
  background-image: url("../assets/Home/como_lo_hacemos/reutilizamos.jpg");
  /* background-repeat: no-repeat; */
  /* background-position: center center; */
  /* background-attachment: fixed; */
  background-size: cover;
  /* background-size: auto; */
}
.imgcenter {
  margin-left: auto;
  margin-right: auto;
}
.imglogo {
  position: absolute;
  width: 35%;
  /* background: transparent; */
  z-index: 99;
}
.centerButtons {
  margin: 0;
  /* width: 100%; */
  /* padding: 0; */
  /* position: absolute; */
  margin-top: 45%;
}
.centerButton {
  position: absolute;
  top: 50%;
  left: 100%;
  width: 50%;
  transform: translate(-100%, -50%);
}
.leftButton {
  position: absolute;
  top: 8%;
  width: 50%;
}
</style>